var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1598_5318)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 27,
    r: 17,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1598_5318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9971 31.9998V31.9993H35.9998V27.9651C35.9998 25.9915 35.575 24.4712 33.2677 24.4712C32.1585 24.4712 31.4142 25.0799 31.1103 25.6569H31.0783V24.6554H28.8906V31.9993H31.1685V28.3629C31.1685 27.4054 31.35 26.4796 32.5358 26.4796C33.704 26.4796 33.7215 27.5723 33.7215 28.4243V31.9998H35.9971Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1816 24.6562H27.4623V32.0001H25.1816V24.6562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3209 21C25.5917 21 25 21.5917 25 22.3209C25 23.0501 25.5917 23.6542 26.3209 23.6542C27.0501 23.6542 27.6418 23.0501 27.6418 22.3209C27.6414 21.5917 27.0497 21 26.3209 21V21Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1598_5318",
    x: 0,
    y: 0,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1598_5318"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1598_5318",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1598_5318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(25 21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactLinkedin);
export default __webpack_public_path__ + "static/media/contactLinkedin.1df6af1dad2dd1a5df815252069c24fd.svg";
export { ForwardRef as ReactComponent };